/** Keep marketing widgets outside active storefront shopping dialogs. */
(() => {
  const root = document.documentElement;
  const paused = new Map();
  const candidates = '#ads-agent-host, #google-merchantwidget-iframe-wrapper, [aria-label="FLYOUT Form"], [aria-label="POPUP Form"]';
  let frame;
  function activePanel() {
    const dialogs = [...document.querySelectorAll('theme-drawer > dialog[open], dialog[open]:not(theme-drawer > dialog)')];
    return dialogs.at(-1);
  }
  function marketingRoot(element) {
    if (element.matches('[aria-label="FLYOUT Form"], [aria-label="POPUP Form"]')) {
      return element.closest('#dynamic-react-root') || element.parentElement;
    }
    return element;
  }
  function sync() {
    frame = undefined;
    const panel = activePanel();
    root.classList.toggle('rl-overlay-active', Boolean(panel));
    if (panel) {
      document.querySelectorAll(candidates).forEach(element => {
        const widget = marketingRoot(element);
        if (!widget || panel.contains(widget) || widget.contains(panel)) return;
        if (!paused.has(widget)) paused.set(widget, widget.inert);
        widget.inert = true;
        widget.setAttribute('data-rl-app-paused', '');
      });
    } else {
      paused.forEach((wasInert, widget) => {
        widget.inert = wasInert;
        widget.removeAttribute('data-rl-app-paused');
      });
      paused.clear();
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'style']
  });
  document.addEventListener('theme-drawer:open', sync);
  document.addEventListener('theme-drawer:close', schedule);
  document.addEventListener('focusin', event => {
    const panel = activePanel();
    if (panel && event.target instanceof Element && event.target.closest('[data-rl-app-paused]')) {
      panel.querySelector('button, input, a[href], [tabindex="0"]')?.focus();
    }
  });
  sync();
})();
